'use client';

import { createContext, ReactNode, useContext, useMemo } from 'react';

import { createFormatter, Formatter } from '@/lib/format';

type FormatContextValue = Formatter;

const FormatContext = createContext<FormatContextValue | null>(null);

type FormatProviderProps = {
    children: ReactNode;
    locale: string;
};

export function FormatProvider({ children, locale }: FormatProviderProps) {
    const contextValue = useMemo(() => createFormatter(locale), [locale]);

    return (
        <FormatContext.Provider value={contextValue}>
            {children}
        </FormatContext.Provider>
    );
}

export function useFormatter() {
    const context = useContext(FormatContext);

    if (!context) {
        throw new Error('useFormatter must be used within a FormatProvider');
    }

    return context;
}
